import React from 'react';
import './Skeleton.css';

export const Skeleton: React.FC<{ width?: string; height?: string; radius?: string; className?: string }> = ({
  width = '100%',
  height = '16px',
  radius = '8px',
  className = ''
}) => (
  <div
    className={`skeleton ${className}`}
    style={{ width, height, borderRadius: radius }}
    aria-hidden="true"
  />
);

export const WorkoutCardSkeleton: React.FC = () => (
  <div className="workout-card skeleton-card">
    <div className="skeleton-row">
      <Skeleton width="140px" height="18px" />
      <Skeleton width="50px" height="22px" radius="8px" />
    </div>
    <Skeleton width="90%" height="14px" />
    <Skeleton width="70%" height="14px" />
    <div className="skeleton-rows">
      <Skeleton width="100%" height="40px" />
      <Skeleton width="100%" height="40px" />
    </div>
  </div>
);

export const StatsSkeleton: React.FC = () => (
  <div className="stats-grid">
    {[0, 1, 2].map(i => (
      <div key={i} className="stat-card">
        <Skeleton width="48px" height="32px" />
        <Skeleton width="70px" height="12px" />
      </div>
    ))}
  </div>
);

export const FeedbackSkeleton: React.FC = () => (
  <div className="feedback-item skeleton-card">
    <div className="skeleton-row">
      <Skeleton width="120px" height="14px" />
      <Skeleton width="80px" height="18px" radius="8px" />
    </div>
    <Skeleton width="100%" height="60px" />
    <Skeleton width="80%" height="20px" />
  </div>
);
